import { MyProfilePage } from './MyProfilePage'
import { withMyProfilePage } from './withMyProfilePage'

const ConnectedMyProfilePage = withMyProfilePage(MyProfilePage)

export { ConnectedMyProfilePage as MyProfilePage }
